import React, { forwardRef } from 'react';

import clsx from 'classnames';

export const InputWrapper = forwardRef(function InputWrapper(
  {
    children,
    className,
    helpText,
    htmlFor,
    label,
    optional,
    touched,
    ...props
  },
  ref
) {
  return (
    <div ref={ref} className={clsx('cdl-input-wrapper', className)} {...props}>
      {children}
      {label && (
        <label className="cdl-input-wrapper__label" htmlFor={htmlFor}>
          {label}
          {optional && (
            <span className="cdl-input-wrapper__label__optional">
              (Optional)
            </span>
          )}
        </label>
      )}
      {helpText && touched && (
        <div className="cdl-input-wrapper__help-text">{helpText}</div>
      )}
    </div>
  );
});
